import {useMemo} from 'react'
import {graphql, useSubscription} from 'react-relay'

import type {useRecentAgentActivitySubscription} from './__generated__/useRecentAgentActivitySubscription.graphql'

// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
const recentAgentActivitySubscription = graphql`
  subscription useRecentAgentActivitySubscription($issueId: ID!, $since: DateTime) {
    issueUpdated(id: $issueId) {
      updateIntentChanged {
        ...useRecentAgentActivity_issue @arguments(since: $since)
      }
    }
  }
`

/**
 * Subscribes to real-time pending agent suggestion updates for an issue.
 *
 * Subscribes to suggestion-specific issue update payloads so only pending
 * suggestion changes refresh this panel, keeping subscription updates scoped.
 *
 * `since` must match the value used by the IssueViewer query so the
 * `recentTriageEvents` selection merges into the same store record.
 */
export function useRecentAgentActivitySubscription(issueId: string, since: string) {
  const config = useMemo(
    () => ({
      subscription: recentAgentActivitySubscription,
      variables: {issueId, since},
    }),
    [issueId, since],
  )

  useSubscription<useRecentAgentActivitySubscription>(config)
}
